import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    Box,
    Button,
    Heading,
    Input,
    FormControl,
    FormLabel,
    FormErrorMessage,
    VStack,
    useToast,
    Flex,
    Spacer,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import axios from 'axios';

const ChangePassword = () => {
    const { isAdmin } = useSelector((state) => state.user);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [password2Error, setPassword2Error] = useState('');
    const toast = useToast();
    const navigate = useNavigate();

    const validatePassword = (value) => {
        let error = '';
        if (!value) {
            error = 'Password is required';
        } else if (value.length < 6) {
            error = 'Password must be at least 6 characters';
        }
        return error;
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setPasswordError(validatePassword(value));
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setPassword2(value);
        setPassword2Error(value !== password ? 'Passwords do not match' : '');
    };

    const changePassword = async () => {
        const isPasswordValid = !passwordError && password.length >= 6;
        const isConfirmPasswordValid = !password2Error && password2 === password && password2.length >= 6;

        if (!isPasswordValid) {
            toast({
                title: 'Invalid New Password',
                description: passwordError || 'Please enter a valid new password.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
            return;
        }

        if (!isConfirmPasswordValid) {
            toast({
                title: 'Invalid Confirm Password',
                description: password2Error || 'Confirm password does not match the new password.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
            return;
        }

        try {
            const accessToken = window.sessionStorage.getItem('accessToken');
            const { data } = await axios.post(
                `https://gyanbackend.aim4u.co.in/changepassword/`,
                { password, password2 },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            toast({
                title: 'Password Changed Successfully',
                description: 'Your password has been updated.',
                status: 'success',
                duration: 5000,
                isClosable: true,
            });
            // Optionally redirect the user after successful password change
            // navigate('/profile');
        } catch (error) {
            console.error('Password change failed:', error);
            toast({
                title: 'Failed to Change Password',
                description: error.response?.data?.message || 'Something went wrong while changing your password. Please try again later.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <Flex direction="column" minH="100vh" bg="gray.50">
            <NavBar isAdmin={isAdmin} />
            <Flex flex="1" align="center" justify="center" p={8}>
                <Box
                    bg="white"
                    borderRadius="md"
                    boxShadow="lg"
                    p={[6, 8]}
                    width={['95%', 'md']}
                >
                    <Heading color="blue.600" mb={6} textAlign="center">
                        Change Your Password
                    </Heading>
                    <VStack spacing={4}>
                        <FormControl isInvalid={passwordError}>
                            <FormLabel htmlFor="new-password" fontWeight="semibold">
                                New Password
                            </FormLabel>
                            <Input
                                id="new-password"
                                placeholder="Enter new password"
                                type="password"
                                value={password}
                                onChange={handlePasswordChange}
                            />
                            <FormErrorMessage>{passwordError}</FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={password2Error}>
                            <FormLabel htmlFor="confirm-password" fontWeight="semibold">
                                Confirm New Password
                            </FormLabel>
                            <Input
                                id="confirm-password"
                                placeholder="Confirm new password"
                                type="password"
                                value={password2}
                                onChange={handleConfirmPasswordChange}
                            />
                            <FormErrorMessage>{password2Error}</FormErrorMessage>
                        </FormControl>

                        <Button
                            bg="blue.500"
                            color="white"
                            _hover={{ bg: 'blue.600' }}
                            onClick={changePassword}
                            width="full"
                            isLoading={false} // You can add an isLoading state if needed
                            fontWeight="semibold"
                        >
                            Update Password
                        </Button>
                    </VStack>
                </Box>
            </Flex>
            <Footer />
        </Flex>
    );
};

export default ChangePassword;